<template>
  <div class="x-date-picker">
    <flat-pickr
      v-model='flatPickrModel'
      :config='config'
      @on-change='changed'
      ref="datePickerWrap"
    >
    </flat-pickr>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { French } from 'flatpickr/dist/l10n/fr.js'

export default {
  name: 'x-date-range-picker',
  components: {
    flatPickr
  },

  props: {
    defaultRange: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data () {
    return {
      flatPickrModel: null,
      range: null,
      config: {
        mode: 'range',
        locale: French,
        inline: true,
        ignoredFocusElements: [document.body],
        defaultDate: this.defaultRange,
        minDate: this.$moment('2017-01-01').toDate(),
        maxDate: this.$moment(new Date()).add('1', 'day').toDate()
      }
    }
  },

  methods: {
    changed (newDates) {
      this.range = newDates
      this.$emit('changed', this.range)
    }
  },

  watch: {
    defaultRange (nVal) {
      // Update flatpickr instance
      this.$refs.datePickerWrap.fp.setDate(nVal)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  @import '~@/styles/datepicker.scss';
</style>
